// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTARecord } from './dta-record';
import {
    DTARecordFromJSON,
    DTARecordFromJSONTyped,
    DTARecordToJSON,
    DTARecordToJSONTyped,
} from './dta-record';

/**
 * 
 * @export
 * @interface DtaListResponse
 */
export interface DtaListResponse {
    /**
     * 
     * @type {number}
     * @memberof DtaListResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<DTARecord>}
     * @memberof DtaListResponse
     */
    items: Array<DTARecord>;
    /**
     * 
     * @type {string}
     * @memberof DtaListResponse
     */
    nextToken?: string;
}

/**
 * Check if a given object implements the DtaListResponse interface.
 */
export function instanceOfDtaListResponse(value: object): value is DtaListResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function DtaListResponseFromJSON(json: any): DtaListResponse {
    return DtaListResponseFromJSONTyped(json, false);
}

export function DtaListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtaListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'items': ((json['items'] as Array<any>).map(DTARecordFromJSON)),
        'nextToken': json['nextToken'] == null ? undefined : json['nextToken'],
    };
}

export function DtaListResponseToJSON(json: any): DtaListResponse {
    return DtaListResponseToJSONTyped(json, false);
}

export function DtaListResponseToJSONTyped(value?: DtaListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'items': ((value['items'] as Array<any>).map(DTARecordToJSON)),
        'nextToken': value['nextToken'],
    };
}
